import { useEffect } from 'react';

/** 첫 진입 시 input에 focus*/
const useFocusSearchInput = (search_dom: HTMLElement | null) => {
	useEffect(() => {
		if (search_dom === null) return;
		search_dom.focus();
	}, [search_dom]);
};

export default useFocusSearchInput;
